import { Color, colors as muiColors } from '@mui/material';

type ColorKeys = 'white' | 'black' | 'grey' | 'red' | 'orange' | 'green' | 'blue' | 'pink' | 'beige' | 'lightGreen' | 'brown';

type PaletteColors = {
  [K in ColorKeys]: K extends 'white' | 'black' ? string : Partial<Color>;
};

export const colors: PaletteColors = {
  black: '#000000',
  white: '#FFFFFF',
  grey: {
    ...muiColors.grey,
    50: '#F5F5F5',
    100: '#FAFAFA',
    200: '#E0E0E0',
    300: '#C7C7C7',
    400: '#ADADAD',
    500: '#727272',
    600: '#616161',
    700: '#4B4B4B',
    800: '#2E2E2E',
    900: '#1A1A1A',
    A100: '#1A1A1ACC',
  },
  red: {
    ...muiColors.red,
    100: '#F3CAC9',
    200: '#EBA5A4',
    300: '#E3807F',
    400: '#DB5A59',
    500: '#D43434',
    600: '#B42626',
    700: '#9D1E1C',
    800: '#851714',
    900: '#6B100D',
  },
  orange: {
    ...muiColors.orange,
    100: '#F8D9C5',
    200: '#F3BE9D',
    300: '#EFA274',
    400: '#EA864B',
    500: '#E66922',
    600: '#C55416',
    700: '#AB480F',
    800: '#913C09',
    900: '#742F05',
  },
  green: {
    ...muiColors.green,
    100: '#B8E4BC',
    200: '#97D89D',
    300: '#76CB7D',
    400: '#56BF5D',
    500: '#3FA846',
    600: '#338738',
    700: '#27722C',
    800: '#1C5D21',
    900: '#134517',
  },
  blue: {
    ...muiColors.blue,
    100: '#C9D6F3',
    200: '#A4BAEB',
    300: '#7F9FE3',
    400: '#5985DB',
    500: '#346BD4',
    600: '#2658B4',
    700: '#1C499D',
    800: '#143A85',
    900: '#0D2C6B',
  },
  pink: {
    ...muiColors.pink,
    100: '#F1CCCC',
    200: '#E3ADAE',
    300: '#D19193',
    400: '#BC797D',
    500: '#A36469',
    600: '#8B4A4C',
    700: '#6F3534',
    800: '#502421',
    900: '#2E1411',
  },
  beige: {
    100: '#E3D2CF',
    200: '#CDB4AE',
    300: '#B6998E',
    400: '#9E7F6F',
    500: '#7E6758',
    600: '#6B584C',
    700: '#574940',
    800: '#453A33',
    900: '#322B26',
  },
  lightGreen: {
    ...muiColors.lightGreen,
    100: '#ECF0E6',
    200: '#DAE0CF',
    300: '#B4BDA2',
    400: '#8D9977',
    500: '#65724E',
    600: '#555E43',
    700: '#4B5239',
    800: '#303625',
    900: '#1E2217',
    A100: '#67715240',
  },
  brown: {
    ...muiColors.brown,
    100: '#F2E6E8',
    200: '#D4B0B5',
    300: '#C08A92',
    400: '#AA5D67',
    500: '#8E4B54',
    600: '#723D43',
    700: '#5A2F34',
    800: '#422326',
    900: '#2A1618',
    A100: '#AA5D6733',
    A200: '#AA5D674D',
    A400: '#AA5D671A',
    A700: '#AA5D6766',
  },
};

// Text/Primary/Button Secondary/color-text-primary-enabled
